export class OpenXmlNumberingListInfo {
    constructor() {
        this.levelOverrides = [];
    }
}
